module.exports = __webpack_public_path__ + "img/1280x720-Technology.c9bb27ba.jpg";